import React, { useState } from "react";
import TogglerBody from "../../TogglerBody";
import ChooseActionTamplate from "../../actionTamplate/ChooseActionTamplate";
import CustomSelectDefoultStyle from "../../customSelect/CustomSelectDefoultStyle";
import CustomSelectUserRole from "../../customSelect/CustomSelectUserRole";
import CustomSelectChanel from "../../customSelect/CustomSelectChanel";
import CounterTemplate from "./CounterTemplate";
import "./statusTamplate.scss";
import CustomSliderRange from "../../sliders/CustomSliderRange";
import TipsTamplate from "../../TipsTamplate";
import {statusActions} from '../../../../constants/common'

const StatusRules = ({ selectedValue, setSelectedValue, data }) => {
  const [isOnMonitor, setIsOnMonitor] = useState(data?.data?.enabled);
  const [currentAction, setCurrentAction] = useState(data?.data?.punishment || "Kick");
  

  return (
    <div style={{ maxWidth: "738px" }} className="status_block_wrap">
      <div className="status_block_wrap_bg"></div>
      <img
        className="status_block_wrap_img"
        src="/img/StatusBlock.svg"
        alt=""
      />
      <h3>Status</h3>
      <div
        className="status_block_item"
        style={{ borderBottom: "1px solid #8D99A3" }}
      >
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isOnMonitor} setIsOn={setIsOnMonitor} keyName={"enabled"} />
          <p>Use Verification Panel</p>
        </div>
      </div>
      <div className="status_block_item">
        <h4 className="status_block_item_title">Rulesets</h4>
      </div>
      <div className="status_block_item rulesets_wrap">
        <div className="rulesets_wrap_item">
          <p>Captcha type</p>
          <CustomSelectDefoultStyle
            keyName={"captchaType"}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
          />
        </div>
        <div className="rulesets_wrap_item">
          <p>Verified User Role</p>
          <CustomSelectUserRole data={data} keyName={"verificationRole"} />
        </div>
        <div className="rulesets_wrap_item">
          <p>Verification Channel</p>
          <CustomSelectChanel data={data} keyName={"verificationChannel"} />
        </div>
        <div className="rulesets_wrap_item">
          <div className="white_list_block_item_title_block flag_customisation_item_wrap_title">
            <p>Time to Solve</p>
            <TipsTamplate
              title={"Time to Solve"}
              label={"Safe"}
              text={
                "<p>Time to Solve option specifies the time window given to users to solve a captcha within. </p>"
              }
              textSecond={""}
            />
          </div>
          <CounterTemplate data={data} keyName={"time"} keyTime={"timePer"} valueTitle=" " valueTime={"min"} timeType={"min"} />
        </div>
        <div className="rulesets_wrap_item">
          <div className="white_list_block_item_title_block flag_customisation_item_wrap_title">
            <p>Prune Action</p>
            <TipsTamplate
              title={"Prune Action"}
              label={"Safe"}
              text={
                "<p>Prune Action defines Themis`s response when a user fails to solve the captcha correctly.</p>"
              }
              textSecond={
                "<p>Punishment specifications can be defined in the Advanced Settings for instances of rule violations.</p>"
              }
            />
          </div>
          <ChooseActionTamplate
            keyName={"punishment"}
            currentAction={currentAction}
            setCurrentAction={setCurrentAction}
            actionArr={statusActions}
          />
        </div>
        <div className="rulesets_wrap_item">
          <div className="white_list_block_item_title_block flag_customisation_item_wrap_title">
            <p>Number of Attempts</p>
            <TipsTamplate
              title={"Number of Attempts"}
              label={"Safe"}
              text={
                "<p>Number of Attempts setting determines how many captcha attempts a user has before Themis enforces a response</p>"
              }
              textSecond={""}
            />
          </div>
          <CustomSliderRange
            data={data}
            keyName={"attempts"}
            currentAction={"Golden"}
            setCurrentAction={setCurrentAction}
            item={statusActions}
          />
        </div>
      </div>
      <div style={{ paddingTop: "50px" }} className="status_block_item">
        <button className="status_block_item_btn_send">Send</button>
      </div>
    </div>
  );
};

export default StatusRules;
